"use client"

import { MixpanelEvent } from "@siro-ai/types"
import { track } from "@/lib/analytics/client"

type LogInEvent = {
	name: typeof MixpanelEvent.logIn.name
	properties: Record<string, never>
}

type SsoEvent = {
	name: typeof MixpanelEvent.sso.name
	properties: { step: string } & Record<string, unknown>
}

export const trackLogIn = () =>
	track<LogInEvent>({
		name: MixpanelEvent.logIn.name,
		properties: {},
	})

export const trackSso = (step: string, properties?: Record<string, unknown>) =>
	track<SsoEvent>({
		name: MixpanelEvent.sso.name,
		properties: { step, ...properties },
	})
